// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5u_CP","buttons":"styles_buttons__2r8d1"};